import $ from 'jquery'

$(document).ready(function() {
	$('.menu-toggle').on('click', function() {
		$(this).toggleClass('is-active')
		$('.mobile-navigation .main-navigation__wrapper ').toggleClass('is-active')
	})

	$('#menu-primary > .menu-item-has-children').click(function() {
		$(this)
			.siblings()
			.removeClass('is-active')
		$(this).toggleClass('is-active')
	})
})
